var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function RowsIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.0001 13C20.5524 13 21 13.4473 21 13.997V20.003C21 20.5536 20.5551 21 20.0001 21H3.99985C3.44765 21 3 20.5527 3 20.003V13.997C3 13.4464 3.44495 13 3.99985 13H20.0001ZM19 15H5V19H19V15ZM20.0001 3C20.5524 3 21 3.44726 21 3.99703V10.003C21 10.5536 20.5551 11 20.0001 11H3.99985C3.44765 11 3 10.5527 3 10.003V3.99703C3 3.44639 3.44495 3 3.99985 3H20.0001ZM19 5H5V9H19V5Z", fill: "" })));
}
export var RowsIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: RowsIconInner }, props))); };
//# sourceMappingURL=RowsIcon.js.map